"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeColors = void 0;
var BadgeColors;
(function (BadgeColors) {
    BadgeColors["GREEN"] = "green";
    BadgeColors["BLACK"] = "black";
    BadgeColors["RED"] = "red";
    BadgeColors["ORANGE"] = "orange";
})(BadgeColors = exports.BadgeColors || (exports.BadgeColors = {}));
//# sourceMappingURL=BadgeProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Badge/BadgeProps.js
// module id = 483
// module chunks = 8